import React from 'react';

export default function MeetingLabelsList(props) {
  let items = props.items.map((item, i) => {
    return (
      <li key={i}>
        <input 
          type="checkbox" 
          checked={item.selected} 
          onClick={props.onChange.bind(null, item)} /> {item.name}
      </li>
    );
  });

  return (
    <ul className="abl-labels-list">
      {items}
    </ul>
  );
};


/** WEBPACK FOOTER **
 ** ./src/js/components/schedule/meeting_labels_list.js
 **/